import { Injectable, signal, inject } from '@angular/core';
import { DashboardApiService } from './dashboard-api.service';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  readonly dashboardApiService = inject(DashboardApiService);

  isCheckingCardAvailability = signal(true);

  getAvailableCardCount() {
    this.isCheckingCardAvailability.set(true);
    return this.dashboardApiService.getCardWidgetDetails().pipe(
      map((res) => {
        this.isCheckingCardAvailability.set(Boolean(!res));
        return res.available ?? null;
      }),
    );
  }
}
